import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import z from 'zod';

import type { MembershipDTO } from '@invenco/accounts-interface';

import { DialogBody, DialogDescription, DialogHeader, DialogTitle } from '@/components/core/dialog';
import { FormDialogContent } from '@/components/forms/form-dialog';
import { TextFormField } from '@/components/forms/text-form-field';
import type { Result } from '@/shared/helpers/Result';

const formSchema = z.object({
  userEmail: z.string().email('Enter a valid email'),
});

type Props = {
  onSubmit: (data: Partial<MembershipDTO>) => Promise<Result>;
};

export function InviteUserDialogContent({ onSubmit }: Props) {
  const form = useForm({
    resolver: zodResolver(formSchema),
    defaultValues: {
      userEmail: '',
    },
  });

  return (
    <FormDialogContent form={form} onSubmit={async (data) => onSubmit(data)}>
      <DialogHeader>
        <DialogTitle>Invite user</DialogTitle>
        <DialogDescription>Send an invitation to join this account.</DialogDescription>
      </DialogHeader>
      <DialogBody>
        <TextFormField
          control={form.control}
          name="userEmail"
          label="User email"
          type="email"
          autoFocus
        />
      </DialogBody>
    </FormDialogContent>
  );
}
